export enum LEAD_ERRORS {
	PARENT = 'parent',
	USER = 'user',
	LEAD = 'lead',
	PARTNER = 'partner',
	LEAD_PARENT = 'lead.parent',
}

export enum PARENT_TYPE_LEAD {
	REQUEST = 'Rbidos::Request',
	BROKER = 'Bg::Request',
	ORDER = 'SberMq::Order',
	RESERVE_ACCOUNT = 'SberMq::ReserveAccount',
	PARTNER = 'Partner',
	ADVERTISEMENT = 'Ad',
}

export enum LEAD_BEARER {
	SMS = 'sms',
	PAPER = 'paper',
	DIGITAL = 'digital',
}

export enum CHECKBOX_OPTIONS {
	OFFER = 'offer',
	PERSONAL_DATA = 'personal_data',
	DIRECTOR = 'director',
}

export const LEAD_ERROR_CODE = {
	WRONG_SMS_CODE: 'wrong_sms_code',
	CODE_EXPIRED: 'code_expired',
	NOT_ACTIVATED: 'not_activated',
	STATE_INVALID: 'state_invalid',
	CREATE_TIMEOUT: 'create_timeout',
	LINK_EXPIRED: 'link_expired',
	SMS_TIMEOUT: 'sms_timeout',
	NO_FIND_ORDER: 'no_find_order',
	COULDNT_FIND_RBIDOS_LEAD: "couldn't find rbidos::lead",
	FUNCTION_UNAVAILABLE: 'function_unavailable',
	TOO_MANY_ATTEMPTS: 'too_many_attempts',
	NOT_FOUND: 'not_found',
	LEAD_COMPETE: 'lead_compete',
	UNKNOWN: 'unknown',
	ATTEMPTS_EXCEEDED: 'attempts_exceeded',
}

export const LEAD_PARENT_ERROR_CODE = {
	LEAD_COMPETE: 'lead_compete',
}

export const ERROR_LEAD_SMS = [
	LEAD_ERROR_CODE.WRONG_SMS_CODE,
	LEAD_ERROR_CODE.CREATE_TIMEOUT,
	LEAD_ERROR_CODE.SMS_TIMEOUT,
	LEAD_ERROR_CODE.TOO_MANY_ATTEMPTS,
	LEAD_ERROR_CODE.CODE_EXPIRED,
]

export const ERROR_LEAD_CODE_TRANSLATE = {
	[LEAD_ERROR_CODE.WRONG_SMS_CODE]: 'Неверный код смс',
	[LEAD_ERROR_CODE.CODE_EXPIRED]: 'Истёк срок действия кода (15 минут)',
	[LEAD_ERROR_CODE.NOT_ACTIVATED]: 'Ошибка создания заявки. Обратитесь в техническую поддержку',
	[LEAD_ERROR_CODE.STATE_INVALID]: 'Ссылка уже была использована ранее',
	[LEAD_ERROR_CODE.CREATE_TIMEOUT]: 'Отправка смс возможна 1 раз в 3 минуты',
	[LEAD_ERROR_CODE.LINK_EXPIRED]: 'Истёк срок действия ссылки (5 минут)',
	[LEAD_ERROR_CODE.SMS_TIMEOUT]: 'Отправка повторной смс возможна 1 раз в 3 минуты',
	[LEAD_ERROR_CODE.NO_FIND_ORDER]: 'Заявка не найдена',
	[LEAD_ERROR_CODE.COULDNT_FIND_RBIDOS_LEAD]: "couldn't find rbidos::lead",
	[LEAD_ERROR_CODE.FUNCTION_UNAVAILABLE]:
		'Функция не доступна. Обратитесь в техническую поддержку.',
	[LEAD_ERROR_CODE.TOO_MANY_ATTEMPTS]:
		'Вы превысили количество попыток ввода кода. Для получения новой ссылки',
	[LEAD_ERROR_CODE.NOT_FOUND]: 'Страница не найдена',
	[LEAD_ERROR_CODE.UNKNOWN]: 'Вы перешли по устаревшей ссылке или что-то пошло не так',
}

export const SECTION_SUCCESS_LEAD_STEP = {
	ACCOUNT: 'step-account',
	ORGANIZATION_QUESTIONNAIRE: 'step-organization-profile',
}

export const SECTION_SUCCESS_LEAD = {
	[SECTION_SUCCESS_LEAD_STEP.ACCOUNT]: 'УЧЕТНАЯ ЗАПИСЬ',
	[SECTION_SUCCESS_LEAD_STEP.ORGANIZATION_QUESTIONNAIRE]: 'АНКЕТА ОРГАНИЗАЦИИ',
	BLOCK_RESULT_TITLE: 'Успешно',
	BLOCK_RESULT_SUB_TITLE: 'Персональные данные и согласие на\u00A0их\u00A0обработку переданы',
	HEADING: 'Регистрация в партнерской программе',
	BUTTON: 'В личный кабинет',
	SUCCESS: 'Успешно',
}

export enum DIRECTOR_LEAD {
	FIRST_USER_IS_NOT_CEO = 'first_user_is_not_ceo',
	CEO_MANUAL_CHANGED = 'ceo_manual_changed',
}

export const directorOptions = [
	{
		label: 'Руководителем организации',
		value: DIRECTOR_LEAD.CEO_MANUAL_CHANGED,
		key: DIRECTOR_LEAD.CEO_MANUAL_CHANGED,
		description: 'На основании выписки (ЕГРЮЛ или ЕГРИП)',
	},
	{
		label: 'Доверенным лицом',
		value: DIRECTOR_LEAD.FIRST_USER_IS_NOT_CEO,
		key: DIRECTOR_LEAD.FIRST_USER_IS_NOT_CEO,
		description: 'Право подписи документов по доверенности',
	},
]

export const enum LogoPosition {
	HEADER = 'header',
	FOOTER = 'footer',
}
